import AlertIcon from '@/common/assets/icons/alert.svg?react';
import Typography from '@/common/components/base/typography/Typography';
import CardButton from '@/common/components/cardButton/CardButton';
import useModal from '@/common/hooks/useModal';
import { FileTypeConst } from '@/common/types/Files.type';
import OfflineShowPhotoInformationModal from '@/modules/OfflineFiles/components/modals/OfflineShowPhotoInformationModal';
import useGetOfflineImages from '@/modules/OfflineFiles/hooks/useGetOfflineImages';
import { OFFLINE_FILES_LINK } from '@/modules/OfflineFiles/OfflineFilesLinks';
import { useNavigate, useParams } from 'react-router-dom';
import { css } from 'styled-system/css';
import { token } from 'styled-system/tokens';

const FileDetailOfflineAlert = ({ fileType }: { fileType: FileTypeConst }) => {
  const { id } = useParams();
  const { closeModal, open, openModal } = useModal();
  const { getCurrentFileOfflineImages } = useGetOfflineImages();
  const navigate = useNavigate();

  const navigateToSendPicture = async () => {
    const { hasOffline } = await getCurrentFileOfflineImages({});
    if (!hasOffline) {
      openModal();
      return;
    }
    navigate(OFFLINE_FILES_LINK.sendOfflinePhotos(+id!));
  };
  const navigateToIncidentParticipantList = async () => {
    navigate(OFFLINE_FILES_LINK.offlinePhotosUsers(+id!));
  };
  return (
    <>
      <CardButton
        cardProps={{
          className: css({
            marginY: '1rem',
            border: '1px solid',
            borderColor: 'orange',
          }),
          onClick:
            fileType === 'property'
              ? navigateToIncidentParticipantList
              : navigateToSendPicture,
        }}
        hasArrow
        arrowColor={token('colors.orange')}
        renderIcon={() => <AlertIcon />}
        title={`ارسال تصاویر ثبت شده`}
        renderTag={() => <Typography color={'orange'}>مشاهده</Typography>}
      />
      <OfflineShowPhotoInformationModal
        confirmButtonText="متوجه شدم"
        open={open}
        closeModal={closeModal}
      />
    </>
  );
};

export default FileDetailOfflineAlert;
